// QR Kiosk v2 — cached-dimmed load-error composition (KV2-5 / bug #10). The designer
// `ReportsError` pattern (kiosk2-states.jsx:83-103) as ONE reusable atom: an amber
// ErrorCallout + Retry above the surface's NORMAL content held at 0.45 opacity and
// pointer-dead (acting on stale rows is the same bug class as blanking them), plus a
// mono "showing cached data from HH:mm" line under it. Never blanks the screen.
//
// Tokens only, no hex. The caller passes its own committed content unchanged as
// children and its committed ErrorCallout props (same keys, same retry dispatch), so
// the dimmed render is pixel-identical to the normal one (children keep their margins).
import React from "react";
import { ErrorCallout } from "./ErrorCallout";

export interface CachedErrorStateProps {
  title: string;
  hint?: string;
  onRetry?: () => void;
  retryLabel: string;
  /** epoch ms — renders the mono cached-from line only when present. */
  cachedAt?: number;
  /** pre-translated "showing cached data from {{time}}" line. */
  cachedLabel?: string;
  /** the surface's NORMAL content JSX, unchanged. */
  children: React.ReactNode;
}

export function CachedErrorState({
  title,
  hint,
  onRetry,
  retryLabel,
  cachedAt,
  cachedLabel,
  children,
}: CachedErrorStateProps) {
  return (
    <>
      <ErrorCallout title={title} hint={hint} onRetry={onRetry} retryLabel={retryLabel} />
      <div style={{ opacity: 0.45, pointerEvents: "none" }} aria-hidden="true">
        {children}
      </div>
      {cachedAt != null && (
        <div
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 9.5,
            color: "var(--faint)",
            textAlign: "center",
            padding: "8px 0 0",
            letterSpacing: "0.04em",
          }}
        >
          {cachedLabel}
        </div>
      )}
    </>
  );
}

export default CachedErrorState;
